import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { Link } from 'react-router-dom';
import OpeningHours from './OpeningHours';


class SpaceNavigation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeCat: props.type[0]
        };
    }

    componentWillMount() {
        const events = this.sortByDate(this.props.events);
        this.upcomingEve = events.filter((o) => {
            return this.getRelTime(o.date) === "upcoming";
        });
        this.pastEve = events.filter((o) => {
            return this.getRelTime(o.date) === "past";
        });

        const exhibitions = this.sortByDate(this.props.exhibitions);
        this.currExh = exhibitions.filter((o) => {
            return this.getRelTime(o.date, o.endDate) === "current";
        });
        this.upcomingExh = exhibitions.filter((o) => {
            return this.getRelTime(o.date, o.endDate) === "upcoming";
        });
        this.pastExh = exhibitions.filter((o) => {
            return this.getRelTime(o.date, o.endDate) === "past";
        });
        console.log(this.upcomingEve, this.pastEve, this.currExh, this.upcomingExh, this.pastExh);
    }

    getRelTime(date, enddate) {
        const now = moment();
        const eventTime = moment(date);
        const diff = eventTime.diff(now);
        if (diff > 0) {
            return "upcoming";
        } else if (diff < 0 && enddate !== undefined) {
            const now = moment();
            const endTime = moment(enddate);
            const enddiff = endTime.diff(now);
            return enddiff > 0 ? "current" : "past";
        } else {
            return "past";
        }
    }

    sortByDate(arr) {
        // sortBy is from oldest (small unix) to newest (big unix)
        // need to reverse, so newest ist [0]
        return _.reverse(_.sortBy(arr, (o) => {
            const d = moment(o.date).unix();
            return d;
        }));
    }

    createLinks(arr) {
        return arr.map((o, i) => {
            const activeCat = o.slug === this.props.slug ? "active" : "";
            return <div key={i} className="happening-link"><Link className={activeCat} to={"/space/"+o.slug} onClick={this.changeEvent.bind(this, o)}>{o.title}</Link></div>;
        });
    }

    changeCategory(cat) {
        this.setState({ activeCat: cat });
        const key = cat + "s";
        const latest = this.sortByDate(this.props[key])[0];
        // when changing category also show default latest happening
        this.changeEvent(latest);
    }

    changeEvent(happening) {
        // send to parent component
        this.props.changeEvent(happening);
    }

    render() {
        const currExhLinks = this.createLinks(this.currExh);
        const upcomingExhLinks = this.createLinks(this.upcomingExh);
        const pastExhLinks = this.createLinks(this.pastExh);
        const upcomingEveLinks = this.createLinks(this.upcomingEve);
        const pastEveLinks = this.createLinks(this.pastEve);
        return (
            <div className="space-nav">
                <div className="top-nav">
                    <Link to="/space" onClick={this.changeCategory.bind(this, "exhibition")}>
                        <button className={this.state.activeCat === "exhibition" ? "active big-btn" : "big-btn"}>Exhibitions</button>
                    </Link>
                    <Link to="/space" onClick={this.changeCategory.bind(this, "event")}>
                        <button className={this.state.activeCat === "event" ? "active big-btn" : "big-btn"}>Events</button>
                    </Link>
                </div>
                <div className="side-nav">
                    { this.state.activeCat === "exhibition" ?
                    <div>
                        { currExhLinks.length > 0 &&
                            <div className="time-filter">
                                <h1>&ndash;current exhibitions</h1> {currExhLinks}
                            </div> }
                        { upcomingExhLinks.length > 0 &&
                            <div className="time-filter">
                                <h1>&ndash;upcoming exhibitions</h1> {upcomingExhLinks}
                            </div> }
                        { pastExhLinks.length > 0 &&
                            <div className="time-filter">
                                 <h1>&ndash;past exhibitions</h1> {pastExhLinks}
                            </div> }
                    </div> :
                    <div>
                        { upcomingEveLinks.length > 0 &&
                            <div className="time-filter">
                                <h1>&ndash;upcoming events</h1> {upcomingEveLinks}
                            </div> }
                        { pastEveLinks.length > 0 &&
                            <div className="time-filter">
                                <h1>&ndash;past events</h1> {pastEveLinks}
                            </div> }
                    </div> }
                    <div className="arrow-down"></div>
                    <OpeningHours />
                </div>
            </div>
        );
    }
}

export default SpaceNavigation;



// WEBPACK FOOTER //
// ./src/components/Space/SpaceNavigation.js